import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  subject_filter: {
    id: 'subject_filter',
    defaultMessage: 'Filtro per categoria',
  },
  subjects: {
    id: 'choose_subject',
    defaultMessage: 'Scegli la categoria',
  },
  parma_text_search_placeholder: {
    id: 'parma_text_search_placeholder',
    defaultMessage: 'Digita la parola chiave',
  },
});
